import { render, staticRenderFns } from "./action.vue?vue&type=template&id=67021206&scoped=true"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"
import style0 from "./action.vue?vue&type=style&index=0&id=67021206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67021206",
  null
  
)

export default component.exports